@if (text) {
  <a (click)="get(true)"><nb-icon icon="attach"></nb-icon>&nbsp;{{ this.text }}</a>
}
@if (isLoading || src) {
  <div (click)="get()" [nbSpinner]="isLoading" nbSpinnerStatus="basic" nbSpinnerSize="small" [style.min-width]="this.width + 'px'" [style.height]="this.height + 'px'">
    @if (src) {
      <img [src]="src" [alt]="this.text || 'Preview'">
    }
  </div>
}


<form #form [action]="target" target="_blank" method="post">
  <!--  <input type="hidden" name="token" [value]="this.auth.token">-->
</form>
